export default __webpack_public_path__ + "static/media/higi.3992f90c.png";